// extracted by mini-css-extract-plugin
module.exports = {"subheader":"SubHeader_subheader__0fqy3"};